<template>
  <div class="add-user-form container my-4 p-4 border rounded shadow-sm bg-white">
    <h3 class="mb-4 text-center">{{ isEditMode ? 'Edit User' : 'Add New User' }}</h3>
    <form @submit.prevent="submitUser" novalidate>
      <div class="mb-3">
        <label for="name" class="form-label">Name <span class="text-danger">*</span></label>
        <input
          type="text"
          id="name"
          class="form-control"
          placeholder="Enter name"
          v-model="form.name"
          required
        />
      </div>
      <div class="mb-3">
        <label for="display_name" class="form-label">Display Name <span class="text-danger">*</span></label>
        <input
          type="text"
          id="display_name"
          class="form-control"
          placeholder="Enter display name"
          v-model="form.display_name"
          required
        />
      </div>
      <div class="mb-3">
        <label for="username" class="form-label">Username <span class="text-danger">*</span></label>
        <input
          type="text"
          id="username"
          class="form-control"
          placeholder="Enter username"
          v-model="form.username"
          required
        />
      </div>
      <div class="mb-3">
        <label for="email" class="form-label">Email <span class="text-danger">*</span></label>
        <input
          type="email"
          id="email"
          class="form-control"
          placeholder="Enter email"
          v-model="form.email"
          required
        />
      </div>
      <div class="d-flex justify-content-between">
        <button type="submit" class="btn btn-primary">
          <i :class="isEditMode ? 'bi bi-pencil-square me-2' : 'bi bi-plus-circle me-2'"></i>
          {{ isEditMode ? 'Update User' : 'Create User' }}
        </button>
        <button type="button" class="btn btn-secondary" @click="$emit('cancel')">
          Cancel
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'AddEditUser',
  props: {
    user: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      form: {
        name: '',
        display_name: '',
        username: '',
        email: ''
      }
    }
  },
  computed: {
    isEditMode() {
      return this.user !== null
    }
  },
  watch: {
    user: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.form = {
            name: newVal.name || '',
            display_name: newVal.display_name || '',
            username: newVal.username || '',
            email: newVal.email || '',
          }
        } else {
          this.form = {
            name: '',
            display_name: '',
            username: '',
            email: '',
          }
        }
      }
    }
  },
  mounted() {
  },
  methods: {
    submitUser() {
      if (!this.form.name.trim()) {
        Swal.fire({ icon: 'warning', title: 'Validation Error', text: 'Name is required.' })
        return
      }
      if (!this.form.display_name.trim()) {
        Swal.fire({ icon: 'warning', title: 'Validation Error', text: 'Display name is required.' })
        return
      }
      if (!this.form.username.trim()) {
        Swal.fire({ icon: 'warning', title: 'Validation Error', text: 'Username is required.' })
        return
      }
      if (!this.form.email.trim()) {
        Swal.fire({ icon: 'warning', title: 'Validation Error', text: 'Email is required.' })
        return
      }

      var payload = {
        "data": {
          name: this.form.name,
          display_name: this.form.display_name,
          username: this.form.username,
          email: this.form.email
        }
      }

      if (this.isEditMode) {
        if (!this.user.user_id) {
          Swal.fire({ icon: 'error', title: 'Error', text: 'User ID is missing. Cannot update user.' })
          return
        }
        axios.put(`/user/sys/${this.user.user_id}`, payload)
          .then(() => {
            Swal.fire({ icon: 'success', title: 'Success', text: 'User updated successfully!' })
            this.$emit('user-updated')
          })
          .catch(() => {
            Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to update user.' })
          })
      } else {
        axios.post('/user/sys/create', payload)
          .then(() => {
            Swal.fire({ icon: 'success', title: 'Success', text: 'User added successfully!' })
            this.form = {
              name: '',
              display_name: '',
              username: '',
              email: '',
            }
            this.$emit('user-added')
          })
          .catch(() => {
            Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to add user.' })
          })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/users/AddEditUser.vue